import { Box, Stack, styled } from "@tm/components"

export const StyledModuleHeader = styled(Stack, {
    name: "DirectSearchModuleHeader",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})(({ theme }) => ({
    flexDirection: "row",
    alignItems: "flex-end",
    padding: `${theme.spacing(0.75)} ${theme.spacing(2)}`,
    backgroundColor: theme.overwrites?.components?.partListV2?.backgroundColor,
}))

export const SearchFieldContainer = styled(Stack)(({ theme }) => ({
    flexDirection: "row",
    gap: theme.spacing(1),
}))

const BASE_TILE_HEIGHT = 460
const TECCOM_REQUEST_BUTTON_PLACEHOLDER_HEIGHT_DIFF = 40
const ERP_AREA_ICON_HEIGHT_DIFF = 25

function getGridAutoRowsHeight(isNoTeccomRequestAvailable?: boolean, hasNoErpAreaIcons?: boolean) {
    let height = BASE_TILE_HEIGHT
    if (isNoTeccomRequestAvailable) {
        height -= TECCOM_REQUEST_BUTTON_PLACEHOLDER_HEIGHT_DIFF
    }
    if (hasNoErpAreaIcons) {
        height -= ERP_AREA_ICON_HEIGHT_DIFF
    }
    return height
}

type TileWrapperProps = {
    isNoTeccomRequestAvailable?: boolean
    hasNoErpAreaIcons?: boolean
}

export const TileWrapper = styled(Box, {
    shouldForwardProp: (prop: string) => !["isNoTeccomRequestAvailable", "hasNoErpAreaIcons"].includes(prop),
})<TileWrapperProps>(({ isNoTeccomRequestAvailable, hasNoErpAreaIcons }) => ({
    display: "grid",
    // dimensions transferred from the mockup (https://zpl.io/WQQnr0j)
    gridAutoRows: getGridAutoRowsHeight(isNoTeccomRequestAvailable, hasNoErpAreaIcons),
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    columnGap: "1rem",
    padding: "0.8rem 0 0.2rem 0",
    alignItems: "stretch",
    justifyContent: "center",
}))
